module.exports = __webpack_public_path__ + "img/fuel.1427c251.svg";